import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z","key":"svg-0"}],["circle",{"cx":"12","cy":"12","r":".5","fill":"currentColor","key":"svg-1"}]]

const IconDice1 = createReactComponent('outline', 'dice-1', 'Dice1', __iconNode);

export default IconDice1;